import { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import CardNotification from "../components/CardNotification";
import { FaPlus, FaSearch, FaTimes, FaRegEdit } from "react-icons/fa";
import './css/ListInstituicao.css';

const ListInstituicao = () => {
    const [instituicoes, setInstituicoes] = useState([]);
    const [notification, setNotification] = useState({ message: '', type: '', show: false });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [nome, setNome] = useState('');
    const [imagem, setImagem] = useState(null);

    useEffect(() => {
        const fetchInstituicao = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/instituicao`);
                setInstituicoes(response.data);
            } catch {
                setNotification({ message: 'Erro ao carregar as Instituições', type: 'error', show: true });
            }
        };
        fetchInstituicao();
    }, []);

    const closeNotification = () => {
        setNotification({ ...notification, show: false });
    };

    const openModal = () => setShowModal(true);
    const closeModal = () => {
        setShowModal(false);
        setShowEdit(false);
        setNome('');
        setImagem(null);
        setSelectedId(null);
    };

    const handleSaveSchool = async (event) => {
        event.preventDefault();
        if (!nome.trim()) {
            setNotification({ message: 'O nome da escola não pode estar vazio!', type: 'error', show: true });
            return;
        }

        const formData = new FormData();
        formData.append('nome_instituicao', nome);
        if (imagem) {
            formData.append('foto_instituicao', imagem);
        }

        try {
            if (showEdit && selectedId) {
                await axios.post(`${process.env.REACT_APP_API_URL}/att-instituicao/${selectedId}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    withCredentials: true
                });
                setNotification({ message: 'Escola atualizada com sucesso!', type: 'success', show: true });
            } else {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/instituicao`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    withCredentials: true
                });
                setInstituicoes([...instituicoes, response.data]);
                setNotification({ message: 'Escola adicionada com sucesso!', type: 'success', show: true });
            }
            setTimeout(() => setNotification({ show: false }), 5000);
            closeModal();
        } catch (error) {
            setNotification({ message: 'Erro ao processar a requisição.', type: 'error', show: true });
        }
    };

    const handleEdit = (instituicao) => {
        setSelectedId(instituicao.id);
        setNome(instituicao.nome_instituicao);
        setShowEdit(true);
        setShowModal(true);
    };

    return (
        <div>
            <Header />
            <Sidebar />
            <div className="instituicao">
                <div className="header-title-instituicao">
                    <h1>Escolas</h1>
                </div>

                {notification.show && (
                    <CardNotification message={notification.message} type={notification.type} onClose={closeNotification} />
                )}

                <div className="body-instituicao">
                    <div className="header-instituicao">
                        <div className="search-instituicao">
                            <FaSearch />
                            <input 
                                placeholder="Procure o nome da Escola..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <button className="button-escola" onClick={openModal}>
                            <FaPlus /> Adicionar Escola
                        </button>
                    </div>
                </div>

                <div className="div-table-instituicao">
                    <table className="instituicao-table">
                        <thead>
                            <tr>
                                <th>Nome da Escola/Cargo</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {instituicoes
                                .filter((inst) =>
                                    inst.nome_instituicao.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                .map((inst) => (
                                    <tr key={inst.id}>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
                                                <img className="foto-escola" src={`${process.env.REACT_APP_API_URL1}/storage/${inst.foto_instituicao}`} alt="Escola" />
                                                <span>{inst.nome_instituicao}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <button className="edit1-button" onClick={() => handleEdit(inst)}>
                                                <FaRegEdit />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal">
                            <button className="close-modal" onClick={closeModal}><FaTimes /></button>
                            <h2>{showEdit ? 'Editar Escola' : 'Adicionar Escola'}</h2>
                            <label>Escreva o nome da escola:</label>
                            <input
                                type="text"
                                placeholder="Nome da Escola"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                            />
                            <div>
                                <label>Escolha uma foto para a escola:</label>
                                <input 
                                    type="file"
                                    onChange={(e) => setImagem(e.target.files[0])}
                                />
                            </div>

                            <div className="modal-buttons">
                                <button onClick={handleSaveSchool} className="save-button">
                                    {showEdit ? 'Atualizar' : 'Salvar'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ListInstituicao;
